module.exports = __webpack_public_path__ + "img/Top_bubble.bc297a39.svg";